<template>
  <div class="loading-container" :style="customStyle">
    <i class="fa fa-spinner loading-animation fa-3x" />
  </div>
</template>

<script>
  export default {
    name: 'Loading',
    props: {
      customStyle: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style>
  .loading-container {
    padding-top: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .loading-animation {
    animation: loading-spin infinite 1s linear;
  }
  @keyframes loading-spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
</style>



// WEBPACK FOOTER //
// src/components/Loading.vue